import React, { useMemo } from 'react';
import { AreaChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToKeyGroupValue, addSyntheticDates, buildChartTitle } from "../chartHelpers";

const Index = ({chart}) => {
    const chartOptions = useMemo(() => ({
        title: buildChartTitle(chart),
        resizable: true,
        height: "100px",
        axes: {
            bottom: { visible: false, scaleType: "time", mapsTo: "date" },
            left: { visible: false, scaleType: "linear", mapsTo: "value" }
        },
        grid: { x: { enabled: false }, y: { enabled: false } },
        color: { gradient: { enabled: true } },
        points: { enabled: false },
        legend: { enabled: false }
    }), [chart]);

    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = addSyntheticDates(transformToKeyGroupValue(panelData, chart));
                return <AreaChart options={chartOptions} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
